
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n/index';
  import LookupNameIds from '@/store/enums/settingsEnums';
  import { Actions } from '@/store/enums/StoreEnums';

  export default defineComponent({
    name: 'package-validation-rule-filter',
    emit: ['type-selected', 'reset'],
    setup: function (props, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref<any>({
        ruleType: '',
        isActive: '',
        classCategoryId: '',
        horseTypeId: '',
        lessonTypeId: '',
      });

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const onSubmit = () => {
        emit('type-selected', selectedItems.value);
      };

      const onReset = () => {
        selectedItems.value = {
          ruleType: '',
          isActive: '',
          classCategoryId: '',
          horseTypeId: '',
          lessonTypeId: '',
        };
        emit('reset', selectedItems.value);
      };

      const lookupsList = computed(() => store.getters.allLookupsList);

      const horseTypes = computed(() =>
        lookupsList.value.filter((lookup) => {
          return lookup.lookupNameId === 16; // HORSE_TYPE
        })
      );

      const lessonTypes = computed(() =>
        lookupsList.value.filter((lookup) => {
          return lookup.lookupNameId === 18; // CLASS_TYPE
        })
      );

      onMounted(async () => {
        await store.dispatch(Actions.GET_PACKAGE_VALIDATION_RULE_TYPES);
      });

      return {
        ruleTypes: computed(() => store.getters.packageValidationRuleTypesList),
        allClassCategories: computed(() => store.getters.allClassCategoryList),
        horseTypes,
        lessonTypes,
        onSubmit,
        onReset,
        translate,
        selectedItems,
      };
    },
  });
